import { flashcards as gaFlashcards, Flashcard } from './flashcards';
import { flashcards as flFlashcards } from './flashcards.fl';
import { flashcards as caFlashcards } from './flashcards.ca';
import { flashcards as txFlashcards } from './flashcards.tx';
import { flashcards as nyFlashcards } from './flashcardsNy';
import { flashcards as njFlashcards } from './flashcardsNj';

// State-aware flashcards provider
// Default: Georgia (ga)
// Florida: fl | California: ca | Texas: tx | New York: ny | New Jersey: nj

export type StateCode = 'ga' | 'fl' | 'ca' | 'tx' | 'ny' | 'nj' | string;

export function getFlashcards(state: StateCode = 'ga'): Flashcard[] {
  switch (state) {
    case 'fl':
      return flFlashcards;
    case 'ca':
      return caFlashcards;
    case 'tx':
      return txFlashcards;
    case 'ny':
      return nyFlashcards;
    case 'nj':
      return njFlashcards;
    case 'ga':
    default:
      return gaFlashcards;
  }
}


